import { ErrorMessage } from "formik";
import { cn } from "src/lib/utils";

const FormLabel = ({ name, label, labelClassName, containerClassName, children }) => {
	return (
		<div className={containerClassName}>
			{!!label && <label className={cn("tw-mb-1 tw-block tw-text-sm tw-font-normal tw-text-gray-600", labelClassName)}>{label}</label>}
			{children}
			{name && <ErrorMessage name={name} component="div" className="tw-block tw-mt-1 tw-text-xs tw-text-destructive" />}
		</div>
	);
};

export default FormLabel;
